export interface INegotiateResponse {
    url: string;
    protocol: serverProtocolEnum,
    signalRTransportProtocol: signalRTransportProtocol,
    messagePack: boolean
}

export enum serverProtocolEnum {
    signalR,
    http
}

export enum signalRTransportProtocol {
    webSocket,
    serverSentEvents
}